import { makeStyles } from "@material-ui/core/styles";
import { Opacity } from "@material-ui/icons";
export const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    justifyContent: "center",
    minHeight: "100%",
    alignItems: "center",
    backgroundColor: "#EDF2F7",
    padding: theme.spacing(2),
  },
  card: {
    display: "flex",
    flexDirection: "column",
    alignSelf: "center",
    width: "100%",
    height: "auto",
    padding: theme.spacing(4),
    gap: "8px",
    margin: 0,
    boxShadow: "none",
    borderRadius: 0,
    backgroundColor: "#FFF",
    [theme.breakpoints.down("sm")]: {
      marginTop: "20px",
      padding: "0px",
    },
  },
  iconWrapper: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },

  titleCon: {
    paddingTop: 0,
    fontFamily: "MontserratRegular",
    fontWeight: 700,
    fontSize: "18px",
    Lineheight: "23.03px",
    textTransform: "capitalize",
  },
  pageHeading: {
    paddingTop: 0,
    fontFamily: "MontserratRegular",
    fontWeight: 700,
    fontSize: "25px",
    Lineheight: "23.03px",
    color: "#2158D0",
  },

  title: {
    fontSize: "2.75rem",
    fontWeight: 700,
    textAlign: "center",
    marginBottom: theme.spacing(2),
  },

  logoWrapper: {
    display: "flex",
    justifyContent: "space-between",
    alignItem: "center",
    "& img": {
      width: "180px",

      [theme.breakpoints.down("md")]: {
        width: "160px",
      },

      [theme.breakpoints.down("sm")]: {
        width: "160px",
      },

      [theme.breakpoints.down("xs")]: {
        width: "150px",
      },
    },
  },

  messageIconWrapper: {
    display: "flex",
    gap: "10px",
    left: "0px",
  },
  titletext: {
    fontWeight: 700,
    fontFamily: "MontserratRegular",
    fontSize: "20px",
    color: "#2158D0",
    textTransform: "capitalize",
  },

  recentPostsContainer: {
    padding: "16px",
    backgroundColor: "#FFF",
    borderRadius: "8px",
    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
  },
  postItem: {
    display: "flex",
    alignItems: "center",
    borderBottom: "1px solid #ddd",
    padding: "8px 0",
  },
  postImage: {
    width: "40px",
    height: "40px",
    borderRadius: "50%",
  },
  postItemText: {
    fontFamily: "MontserratRegular",
    "& .MuiListItemText-primary": {
      color: "black",
      fontFamily: "MontserratRegular",
      fontWeight: "700",
      Size: "20px",
      LineHeight: "20.15px",
    },
  },

  divider: {
    width: "2px",
    height: "40px",
    backgroundColor: "#00000033",
    margin: "0 10px",
  },
  checkboxLabel: {
    marginLeft: theme.spacing(-1),
    width: "100%",
  },
  radioGroup: {
    marginLeft: theme.spacing(1),
  },
  radioRoot: {
    "& .MuiSvgIcon-root": {
      color: "#5C91FF",
    },
    "&.Mui-checked .MuiSvgIcon-root": {
      color: "#5C91FF",
    },
  },
  radioLabel: {
    marginBottom: theme.spacing(1),
    "& .MuiTypography-body1": {
      color: "black",
      fontSize: "14px",
      fontWeight: 400,
      fontfamily: "MontserratRegular",
      lineHeight: "1.5",
    },
  },
  buttonContainer: {
    marginTop: theme.spacing(4),
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
  },
  saveButton: {
    padding: theme.spacing(1.5),
    fontWeight: 700,
    textTransform: "none",
    borderRadius: 8,
    backgroundColor: "#5C91FF",
    color: "white",
  },
  unsubscribeButton: {
    color: "#E53E3E",
    fontWeight: 800,
    display: "flex",
    alignItems: "center",
    marginTop: "20px",
    justifyContent: "flex-start",
  },

  buttonContent: {
    display: "flex",
    alignItems: "start",
    gap: "12px",
    textTransform: "capitalize",
  },

  listItem: {
    padding: theme.spacing(1.5, 0),
  },
  notificationItem: {
    padding: theme.spacing(1.5, 0),
    "& .MuiTypography-body1": {
      color: "#000000",
      fontSize: "14px",
      fontWeight: 400,
      fontfamily: "MontserratRegular",
      lineHeight: "1.5",
    },
  },

  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: theme.spacing(4),
  },
  logo: {
    width: 48,
    height: 48,
  },
  settingsList: {
    padding: 0,
  },
  sectionTitle: {
    fontWeight: 700,
    fontSize: "20px",
    color: "#000000",
    fontStyle: "bold",
    fontFamily: "MontserratRegular",
    lineHeight: "23.03px",
  },
  sectionSubtitle: {
    color: "#718096",
    fontSize: "0.9rem",
  },
  backIcon: {
    width: 32,
    height: 32,
    cursor: "pointer",
  },
  mainTitle: {
    fontWeight: 700,
    color: "#2158D0",
    marginBottom: theme.spacing(3),
    textTransform: "capitalize",
  },
  switchBtn: {
    color: "#5C91FF",
    "& .Mui-checked .MuiSwitch-thumb": {
      backgroundColor: "#5C91FF",
    },
  },

  searchInput: {
    backgroundColor: "#EDF2F7",
    borderRadius: 8,
    padding: theme.spacing(0, 2),
    height: "50px",
    display: "flex",
    flexGrow: 1,
    "& .MuiInputBase-root": {
      display: "flex",
      flexDirection: "row-reverse",
      alignItem: "center",
      justifyContent: "center",
    },
    marginBottom: "20px",
  },
  communityHeading: {
    paddingTop: 0,
    fontFamily: "MontserratRegular",
    fontWeight: 700,
    fontSize: "20px",
    Lineheight: "23.03px",
    color: "#000000",
    textTransform: "capitalize",
  },
  channelListCard: {
    display: "flex",
    backgroundColor: "#EDF2F7",
    borderRadius: "10px",
    boxShadow: "none",
    flexDirection: "row-reverse",
    justifyContent: "space-between",
  },
  channelCardDetails: {
    display: "flex",
    flexDirection: "column",
  },
  content: {
    flex: "1 0 auto",
    "&:last-child": {
      display: "flex",
      flexDirection: "column",
      gap: "20px",
    },
  },
  channelListingButton: {
    backgroundColor: "#5C91FF",
    color: "white",
    width: "215px",
    height: "50px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    fontSize: "16px",
    fontWeight: "bold",
    border: "none",
    cursor: "pointer",
    paddingRight: "20px",

    "& .MuiButton-label": {
      justifyContent: "space-between",
    },
    "&:hover::after": {
      transform: "translateX(5px)",
    },

    "&:hover": {
      backgroundColor: "#4A7ED6",
    },
  },
  subscribeButton: {
    backgroundColor: "#5C91FF",
    color: "white",
    width: "215px",
    height: "50px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "20px",
    textTransform: "capitalize",
    "&:hover": {
      backgroundColor: "#4A7ED6",
    },
  },
  searchPostTitle: {
    marginTop: "20px",
    "& p": {
      color: "#2158D0",
      fontWeight: "700",
      fontFamily: "Istok Web",
      fontSize: "24px",
    },
  },
  subscribeFlag: {
    margin: "10px",
  },
  textField: {
    width: "calc(100% - 120px)",
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    backgroundColor: "#F5F5F5",
    borderRadius: "10px",
    '& input[type="file"]': {
      opacity: 0,
      cursor: "pointer",
      width: "100%",
      height: "100%",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none", // Removes the border
    },
  },

  form: {
    padding: theme.spacing(2),
    paddingBottom: theme.spacing(5),
    margin: "auto",
    minWidth: 400,
  },
  formLabel: {
    color: "#2158D0",
    display: "block",
    textAlign: "left",
    fontWeight: 700,
    fontSize: "20px",
    lineHeight: "28.79px",
    fontFamily: "Istok Web",
    marginTop: "0px",
    marginBottom: "-8px",
  },
  inputStyle: {
    border: 0,
    backgroundColor: "white",
    color: "#F5F5F5",
  },
  submitBtn: {
    background: "#5C91FF",
    color: "#FFFFFF",
    textTransform: "capitalize",
    marginRight: "20px",
    borderRadius: 6,
    padding: "11px 11px",
    width: "calc(100% - 120px)",
    marginBottom: theme.spacing(2),
    "&:hover": {
      background: "#5C91FF",
    },
    "& .MuiButton-fullWidth": {
      width: "calc(100% - 120px)",
    },
    fontWeight: 700,
    fontSize: "20px",
  },
  cardHeader: {
    display: "flex",
    justifyContent: "flex-start",
    marginLeft: "80px",
    [theme.breakpoints.down("sm")]: {
      justifyContent: "center",
      marginLeft: "0px",
    },
  },
  listText: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    [theme.breakpoints.down("sm")]: {
      justifyContent: "center",
    },
  },
}));
